import { useState } from "react";
import styles from "./styles.module.scss";
import { getPlanDuration, getPlanPricing } from "../../utils/getPlanDetails";
import { Card } from "../card";
import { PaymentButton } from "../../paymentButton";
import PaddleCheckout from "../../paypal";
import paypal from "@assets/img/png/PayPal.png";
import Visa from "@assets/img/png/Visa.png";
import MasterCard from "@assets/img/png/MasterCard.png";
import Maestro from "@assets/img/png/Maestro.png";

import { usePaymentButtonMethod } from "../../hooks/usePaymentMethod";
import { formatPeriodUnit } from "@utils/formatUnit";
import { CardLogos } from "../cardLogos";

export const CustomCheckoutModal = ({
  onClose,
  activePlan,
  showTimer,
  isWalky,
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("credit-card");

  const isTrial = localStorage.getItem("isTrial") === "true";
  const isLegacyPlan = activePlan.uiDisplayOptions.legacyPlan;

  const planDetails = getPlanPricing(activePlan);
  const { idPrefix } = usePaymentButtonMethod();

  const priceNew =
    isLegacyPlan && !isTrial
      ? planDetails.priceNew
      : planDetails.trialPriceAmount;
  const priceOld =
    isLegacyPlan && !isTrial
      ? planDetails.priceOld
      : planDetails.trialNoDiscountPriceAmount;
  const discountPercentage =
    isLegacyPlan && !isTrial
      ? planDetails.discountPercentage
      : planDetails.trialDiscountPercentage;
  const savings = (priceOld - priceNew).toFixed(2);

  const currency = planDetails.currency;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>

        <h3>Select your payment method</h3>

        <div className={styles.switch}>
          <div
            onClick={() => setSelectedPaymentMethod("paypal")}
            className={`${styles.switchItem} ${
              selectedPaymentMethod === "paypal" ? styles.active : ""
            }`}
          >
            <div className={styles.paypal}>
              <img src={paypal} alt="paypal" />
            </div>
          </div>
          <div
            onClick={() => setSelectedPaymentMethod("credit-card")}
            className={`${styles.switchItem} ${
              selectedPaymentMethod === "credit-card" ? styles.active : ""
            }`}
          >
            <div className={styles.card}>
              <h5>Credit card</h5>
              <div className={styles.cards}>
                <img src={Visa} alt="Visa" />
                <img src={MasterCard} alt="MasterCard" />
                <img src={Maestro} alt="Maestro" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.price}>
          <div className={styles.regularPrice}>
            <span>
              {isLegacyPlan && !isTrial
                ? formatPeriodUnit(
                    planDetails.billingPeriodDuration,
                    planDetails.billingPeriodUnit
                  )
                : formatPeriodUnit(
                    planDetails.trialPeriodDuration,
                    planDetails.trialPeriodUnit
                  )}{" "}
              plan
            </span>
            <span>
              {isLegacyPlan && !isTrial
                ? planDetails.priceOld
                : planDetails.trialNoDiscountPriceAmount}{" "}
              {currency}
            </span>
          </div>

          <div className={styles.planDetails}>
            <p>{discountPercentage}% introductory discount</p>
            <p>
              <span>
                {" "}
                -{savings} {currency}
              </span>
            </p>
          </div>

          <div className={styles.totalPrice}>
            <span>Total</span>
            <span>
              {isLegacyPlan && !isTrial
                ? planDetails.priceNew
                : planDetails.trialPriceAmount}{" "}
              {currency}{" "}
              <span className={styles.billingTotal}>
                for{" "}
                {isTrial
                  ? "1 Week"
                  : formatPeriodUnit(
                      planDetails.billingPeriodDuration,
                      planDetails.billingPeriodUnit,
                      false
                    )}{" "}
              </span>
            </span>
          </div>

          <p className={styles.discountText}>
            You just saved {savings} {currency} ({discountPercentage}% off)
          </p>
        </div>
        <hr />
        <div className={styles.payment}>
          {selectedPaymentMethod === "paypal" ? (
            <div className={styles.paypal}>
              <PaddleCheckout
                id="paywall_continue_modal_paypal"
                isWalky={isWalky}
              />
            </div>
          ) : (
            <div>
              <div className={styles.paymentButton}>
                <PaymentButton
                  id={`paywall_continue_modal_${idPrefix}`}
                  isWalky={isWalky}
                />
              </div>
              <div className={styles.cardWrapper}>
                <CardLogos />
                <Card
                  id="paywall_continue_modal_card"
                  isInModal
                  isWalky={isWalky}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
